<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    items?: {
      title: string
      description: string
      icon?: string
    }[]
  }>(),
  {
    title: 'Semua Fitur Pengiriman, Langsung dari Dashboard Shopify',
    items: () => [
      {
        title: 'Cek Ongkir Real Time',
        description:
          'Tampilkan ongkos kirim dari JNE, J&T Express, IDExpress, SiCepat, dan banyak ekspedisi lain saat checkout.',
        icon: 'material-symbols:fact-check-outline'
      },
      {
        title: 'Cetak & Lacak Resi Otomatis',
        description:
          'Resi langsung terbit begitu order dikonfirmasi, pelanggan dapat tracking real-time tanpa keluar dari toko Anda.',
        icon: 'material-symbols:print-outline'
      },
      {
        title: 'Install Mudah & Cepat',
        description:
          'Install plugin langsung dari Shopify App Store, aktifkan kurir pilihan dan mulai kirim tanpa coding.',
        icon: 'material-symbols:install-desktop'
      }
    ]
  }
)

const chunked = computed(() => {
  // chunk props.items to max 3 items per array
  const chunkSize = 3
  const chunks = []
  for (let i = 0; i < (props.items?.length ?? 0); i += chunkSize) {
    chunks.push(props.items?.slice(i, i + chunkSize))
  }
  return chunks
})
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle class="text-center" :title="title" />

      <div class="space-y-6">
        <div
          class="grid lg:inline-grid lg:mx-auto grid-cols-1 gap-6 justify-center lg:grid-cols-3"
        >
          <UiCardFeature
            v-for="(item, key) in chunked[0]"
            :key="key"
            :icon="item.icon"
            icon-size="33px"
            :title="item.title"
            :description="item.description"
          />
        </div>
        <div
          class="grid lg:inline-grid lg:px-32 lg:mx-auto grid-cols-1 gap-6 justify-center lg:grid-cols-2"
        >
          <UiCardFeature
            v-for="(item, key) in chunked[1]"
            :key="key"
            :icon="item.icon"
            icon-size="33px"
            :title="item.title"
            :description="item.description"
          />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
